export const CROPS_REQUEST_SUCCESS = "crops-request-success";
export const CLEANUP = 'cleanup';


export const FETCH_CROPS_YIELD_EVOLUTION_REQUEST = 'fetch-crops-yield-evolution-request';
export const FETCH_CROPS_YIELD_EVOLUTION_SUCCESS = 'fetch-crops-yield-evolution-success';
export const FETCH_CROPS_YIELD_EVOLUTION_FAILED = 'fetch-crops-yield-evolution-failed';
